import { TextField, Typography } from '@mui/material';
import EATooltip from 'components/common/EATooltip';
import useStyles from 'style/js-style/components/inputs/PrefixedInputStyle';

export default function PrefixedTextField({ prefix, ...props }) {
	const { classes } = useStyles();

	return (
		<div className={classes.root}>

			<div className={classes.prefixWrapper}>
				<EATooltip title={prefix} arrow placement="top">
					<Typography
						variant="body2"
						className={classes.prefix}
					>
						{prefix}
					</Typography>
				</EATooltip>
			</div>

			<TextField
				variant="outlined"
				className={classes.inputField}
				InputProps={{
					sx: {
						borderRadius: '0 12px 12px 0',
						backgroundColor: 'white',
						height: '40px',
						pl: 2
					},
				}}
				{...props}
			/>
		</div>
	);
}